import { useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router";
import Loading from "../components/Loading";

export default function SupervisaoRoutes() {
    const auth = useAuth();
    if(auth.loading) {
        return (
            <Loading />
        )
    }
    return auth.user.id === 4 || auth.user.id === 1 || auth.user.id === 45 || auth.user.id === 41 || auth.user.id === 43 || auth.user.id === 48 ? <Outlet /> : <Navigate to="/" />
}